import { createSlice } from "@reduxjs/toolkit";

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    isProduct: false,
    isCheckoutToShow: false,
    isProductRegisterSuccessToShow: false,
    registerProductId: null,
    productData: {},
    sessionData: {},
  },
  reducers: {
    setIsCheckoutToShow: (state, action) => {
      state.isCheckoutToShow = action.payload;
    },
    setIsProductRegisterSuccessToShow: (state, action) => {
      state.isProductRegisterSuccessToShow = action.payload;
    },
    setRegisteProductId: (state, action) => {
      state.registerProductId = action.payload;
    },
    setCheckoutType: (state, action) => {
      state.isProduct = action.payload;
    },
    setProductData: (state, action) => {
      state.productData = action.payload;
    },
    setSessionData: (state, action) => {
      state.sessionData = action.payload;
    },
  },
  selectors: {
    getIsCheckoutToShow: (state) => state.isCheckoutToShow,
    getCheckoutType: (state) => state.isProduct,
    getIsProductRegisterSuccessToShow: (state) => state.isProductRegisterSuccessToShow,
    getRegisterProdutId: (state) => state.registerProductId,
    getProductData: (state) => state.productData,
    getSessionData: (state) => state.sessionData,
  },
});

export const {
  setCheckoutType,
  setIsCheckoutToShow,
  setProductData,
  setSessionData,
  setIsProductRegisterSuccessToShow,
  setRegisteProductId,
} = checkoutSlice.actions;
export const {
  getCheckoutType,
  getIsCheckoutToShow,
  getProductData,
  getSessionData,
  getIsProductRegisterSuccessToShow,
  getRegisterProdutId,
} = checkoutSlice.selectors;
